import { Component, Inject, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Subscription } from "rxjs";
import { ApiService } from "src/app/providers/api.service";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";
import * as moment from 'moment';
import { log } from "util";
import { NgxMatTimepickerComponent } from "ngx-mat-timepicker/lib/components/ngx-mat-timepicker/ngx-mat-timepicker.component";

@Component({
  selector: "sm-slot-timings",
  templateUrl: "./slot-timings.component.html",
  styleUrls: ["./slot-timings.component.scss"],
})
export class SlotTimingsComponent implements OnInit, OnDestroy {
  @ViewChild('pickerA', { static: false }) pickerA!: NgxMatTimepickerComponent;
  loader: boolean = false;
  apisub: Subscription;
  todayData: any[] = [];
  tomorrowData: any[] = [];
  constructor(
    private apiservice: ApiService,
    @Inject(MAT_DIALOG_DATA) public parentdata: any,
    private loaderservice: LoaderServiceService,
    private activemodal: MatDialogRef<SlotTimingsComponent>
  
  ) {

    this.apisub = this.apiservice.apiResult.subscribe(data =>{
      if (
        data.responseType == SM_CONSTANTS.RESULT_API_GET_SHOP_SERVICE_TIMINGS
      ) {
        this.todayData = []
        this.tomorrowData = []
        if (data.result) {
          // this.isLoader=false;
          console.log(data);
          data.result.forEach((element: any) => {
            // console.log(element);
            element.timeList = typeof element.timeList == 'string' ? JSON.parse(element.timeList) : element.timeList;
            let tomorrowDay: any;
            let currDay = this.parentdata.day;
            console.log(currDay);
            if (currDay > 6) {
              tomorrowDay = 1;
            } else {
              tomorrowDay = currDay + 1;
            }
            if (element.timeList[0].day == '1') { 
              let timeSlots: any[] = []
              let try1: any[] = []
              element.timeList.forEach((item:any) => {
                // timeSlots.push(this.getTime(
                //   item.openTime,
                //   item.closeTime,
                //   '60'
                // ))
                try1 = this.getTime(
                    item.openTime,
                    item.closeTime,
                    '60'
                  )
                timeSlots = [...timeSlots, ...try1]


              });
              console.log("timeslots::::", timeSlots);  
              // console.log(timeSlots);
              if (currDay == 1) {
                this.todayData = timeSlots;
              }
              if (tomorrowDay == 1) {
                this.tomorrowData = timeSlots;
              }
            } else if (element.timeList[0].day == '2') {
              let timeSlots: any[] = []
              let try1: any[] = []
              element.timeList.forEach((item:any) => {
                // timeSlots.push(this.getTime(
                //   item.openTime,
                //   item.closeTime,
                //   '60'
                // ))
                try1 = this.getTime(
                    item.openTime,
                    item.closeTime,
                    '60'
                  )
                timeSlots = [...timeSlots, ...try1]


              });
              console.log("timeslots::::", timeSlots);
              // console.log(timeSlots);
              if (currDay == 2) {
                this.todayData = timeSlots;
              }
              if (tomorrowDay == 2) {
                this.tomorrowData = timeSlots;
              }
            } else if (element.timeList[0].day == '3') {
              let timeSlots: any[] = []
              let try1: any[] = []
              element.timeList.forEach((item:any) => {
                // timeSlots.push(this.getTime(
                //   item.openTime,
                //   item.closeTime,
                //   '60'
                // ))
                try1 = this.getTime(
                    item.openTime,
                    item.closeTime,
                    '60'
                  )
                timeSlots = [...timeSlots, ...try1]


              });
              console.log("timeslots::::", timeSlots);
              // console.log(timeSlots);
              if (currDay == 3) {
                this.todayData = timeSlots;
              }
              if (tomorrowDay == 3) {
                this.tomorrowData = timeSlots;
              }
            } else if (element.timeList[0].day == '4') {
              let timeSlots: any[] = []
              let try1: any[] = []
              element.timeList.forEach((item:any) => {
                // timeSlots.push(this.getTime(
                //   item.openTime,
                //   item.closeTime,
                //   '60'
                // ))
                try1 = this.getTime(
                    item.openTime,
                    item.closeTime,
                    '60'
                  )
                timeSlots = [...timeSlots, ...try1]


              });
              console.log("timeslots::::", timeSlots);
              // console.log(timeSlots);
              if (currDay == 4) {
                this.todayData = timeSlots;
              }
              if (tomorrowDay == 4) {
                this.tomorrowData = timeSlots;
              }
            } else if (element.timeList[0].day == '5') {
              let timeSlots: any[] = []
              let try1: any[] = []
              element.timeList.forEach((item:any) => {
                // timeSlots.push(this.getTime(
                //   item.openTime,
                //   item.closeTime,
                //   '60'
                // ))
                try1 = this.getTime(
                    item.openTime,
                    item.closeTime,
                    '60'
                  )
                timeSlots = [...timeSlots, ...try1]


              });
              console.log("timeslots::::", timeSlots);
              // console.log(timeSlots);
              if (currDay == 5) {
                this.todayData = timeSlots;
              }
              if (tomorrowDay == 5) {
                this.tomorrowData = timeSlots;
              }
            } else if (element.timeList[0].day == '6') {
              let timeSlots: any[] = []
              let try1: any[] = []
              element.timeList.forEach((item:any) => {
                // timeSlots.push(this.getTime(
                //   item.openTime,
                //   item.closeTime,
                //   '60'
                // ))
                try1 = this.getTime(
                    item.openTime,
                    item.closeTime,
                    '60'
                  )
                timeSlots = [...timeSlots, ...try1]


              });
              console.log("timeslots::::", timeSlots);
              // console.log(timeSlots);
              if (currDay == 6) {
                this.todayData = timeSlots;
              }
              if (tomorrowDay == 6) {
                this.tomorrowData = timeSlots;
              }
            } else if (element.timeList[0].day == '7') {
              let timeSlots: any[] = []
              let try1: any[] = []
              element.timeList.forEach((item:any) => {
                // timeSlots.push(this.getTime(
                //   item.openTime,
                //   item.closeTime,
                //   '60'
                // ))
                try1 = this.getTime(
                    item.openTime,
                    item.closeTime,
                    '60'
                  )
                timeSlots = [...timeSlots, ...try1]


              });
              console.log("timeslots::::", timeSlots);
              // console.log(timeSlots);
              if (currDay == 7) {
                this.todayData = timeSlots;
              }
              if (tomorrowDay == 7) {
                this.tomorrowData = timeSlots;
              }
            }
          });
          let currTime: any = new Date();
          // console.log(currTime);
          this.todayData.forEach((item) => {
            if(parentdata.isToday){

              let fromTime: any = new Date(currTime).setHours(
                item.startTime.slice(0, 2),
                item.startTime.slice(3, 5),
                0,
                0
              );
              let toTime: any = new Date(currTime).setHours(
                item.endTime.slice(0, 2),
                item.endTime.slice(3, 5),
                0,
                0
              );
              // console.log(fromTime,toTime);
              if (fromTime <= currTime && currTime <= toTime) {
                console.log(
                  'Time is between ' +
                  item.startTime +
                    ' and ' +
                    item.endTime
                );
                item.status = 1;
              } else if (fromTime >= currTime) {
                item.status = 1;
              } else {
                console.log(
                  'Time is not between ' +
                  item.startTime +
                    ' and ' +
                    item.endTime
                );
                item.status = 0;
              }
            }
            else{
              item.status = 1
            }
              // console.log(element);

          });
          // this.todayData=[];
          // this.tomorrowData=[];
          console.log(this.todayData);
          // this.apiService.getEntitySlotInfoWithBookingCount(this.entity_id, this.type,this.selectedValue == 1 ? '0' : '1')
        }

        this.loaderservice.showLoader = false
        this.loader = false
        if(this.todayData.length == 0){
          setTimeout(() => {
            this.pickerA.open(); // Open the timepicker once the component has loaded
          }, 0);

        }

      } else if (
        data.responseType == SM_CONSTANTS.RESULT_API_GET_HOME_SERVICE_TIMINGS
      ) {
        this.todayData = []
        this.tomorrowData = []
        if (data.result) {

          console.log(data);
          data.result.forEach((element: any) => {
            // console.log(element);
            element.timeList = typeof element.timeList == 'string' ? JSON.parse(element.timeList) : element.timeList;
            let tomorrowDay: any;
            let currDay = this.parentdata.day
            console.log(currDay);
            if (currDay > 6) {
              tomorrowDay = 1;
            } else {
              tomorrowDay = currDay + 1;
            }
            if (element.timeList[0].day == '1') {
              let timeSlots: any[] = []
              let try1: any[] = []
              element.timeList.forEach((item:any) => {
                // timeSlots.push(this.getTime(
                //   item.openTime,
                //   item.closeTime,
                //   '60'
                // ))
                try1 = this.getTime(
                    item.openTime,
                    item.closeTime,
                    '60'
                  )
                timeSlots = [...timeSlots, ...try1]


              });
              console.log("timeslots::::", timeSlots);
              if (currDay == 1) {
                this.todayData = timeSlots;
              }
              if (tomorrowDay == 1) {
                this.tomorrowData = timeSlots;
              }
            } else if (element.timeList[0].day == '2') {
              let timeSlots: any[] = []
              let try1: any[] = []
              element.timeList.forEach((item:any) => {
                // timeSlots.push(this.getTime(
                //   item.openTime,
                //   item.closeTime,
                //   '60'
                // ))
                try1 = this.getTime(
                    item.openTime,
                    item.closeTime,
                    '60'
                  )
                timeSlots = [...timeSlots, ...try1]


              });
              console.log("timeslots::::", timeSlots);
              if (currDay == 2) {
                this.todayData = timeSlots;
              }
              if (tomorrowDay == 2) {
                this.tomorrowData = timeSlots;
              }
            } else if (element.timeList[0].day == '3') {
              let timeSlots: any[] = []
              let try1: any[] = []
              element.timeList.forEach((item:any) => {
                // timeSlots.push(this.getTime(
                //   item.openTime,
                //   item.closeTime,
                //   '60'
                // ))
                try1 = this.getTime(
                    item.openTime,
                    item.closeTime,
                    '60'
                  )
                timeSlots = [...timeSlots, ...try1]


              });
              console.log("timeslots::::", timeSlots);
              if (currDay == 3) {
                this.todayData = timeSlots;
              }
              if (tomorrowDay == 3) {
                this.tomorrowData = timeSlots;
              }
            } else if (element.timeList[0].day == '4') {
              let timeSlots: any[] = []
              let try1: any[] = []
              element.timeList.forEach((item:any) => {
                // timeSlots.push(this.getTime(
                //   item.openTime,
                //   item.closeTime,
                //   '60'
                // ))
                try1 = this.getTime(
                    item.openTime,
                    item.closeTime,
                    '60'
                  )
                timeSlots = [...timeSlots, ...try1]


              });
              console.log("timeslots::::", timeSlots);
              if (currDay == 4) {
                this.todayData = timeSlots;
              }
              if (tomorrowDay == 4) {
                this.tomorrowData = timeSlots;
              }
            } else if (element.timeList[0].day == '5') {
              let timeSlots: any[] = []
              let try1: any[] = []
              element.timeList.forEach((item:any) => {
                // timeSlots.push(this.getTime(
                //   item.openTime,
                //   item.closeTime,
                //   '60'
                // ))
                try1 = this.getTime(
                    item.openTime,
                    item.closeTime,
                    '60'
                  )
                timeSlots = [...timeSlots, ...try1]


              });
              console.log("timeslots::::", timeSlots);
              if (currDay == 5) {
                this.todayData = timeSlots;
              }
              if (tomorrowDay == 5) {
                this.tomorrowData = timeSlots;
              }
            } else if (element.timeList[0].day == '6') {
              let timeSlots: any[] = []
              let try1: any[] = []
              element.timeList.forEach((item:any) => {
                // timeSlots.push(this.getTime(
                //   item.openTime,
                //   item.closeTime,
                //   '60'
                // ))
                try1 = this.getTime(
                    item.openTime,
                    item.closeTime,
                    '60'
                  )
                timeSlots = [...timeSlots, ...try1]


              });
              console.log("timeslots::::", timeSlots);
              if (currDay == 6) {
                this.todayData = timeSlots;
              }
              if (tomorrowDay == 6) {
                this.tomorrowData = timeSlots;
              }
            } else if (element.timeList[0].day == '7') {
              let timeSlots: any[] = []
              let try1: any[] = []
              element.timeList.forEach((item:any) => {
                // timeSlots.push(this.getTime(
                //   item.openTime,
                //   item.closeTime,
                //   '60'
                // ))
                try1 = this.getTime(
                    item.openTime,
                    item.closeTime,
                    '60'
                  )
                timeSlots = [...timeSlots, ...try1]


              });
              console.log("timeslots::::", timeSlots);
              if (currDay == 7) {
                this.todayData = timeSlots;
              }
              if (tomorrowDay == 7) {
                this.tomorrowData = timeSlots;
              }
            }
          });
          let currTime: any = new Date();
          // console.log(currTime);
          this.todayData.forEach((element) => {
           if(parentdata.isToday){
             // console.log(element);
             let fromTime: any = new Date(currTime).setHours(
              element.startTime.slice(0, 2),
              element.startTime.slice(3, 5),
              0,
              0
            );
            let toTime: any = new Date(currTime).setHours(
              element.endTime.slice(0, 2),
              element.endTime.slice(3, 5),
              0,
              0
            );
            // console.log(fromTime,toTime);
            if (fromTime <= currTime && currTime <= toTime) {
              console.log(
                'Time is between ' +
                  element.startTime +
                  ' and ' +
                  element.endTime
              );
              element.status = 1;
            } else if (fromTime >= currTime) {
              element.status = 1;
            } else {
              console.log(
                'Time is not between ' +
                  element.startTime +
                  ' and ' +
                  element.endTime
              );
              element.status = 0;
            }
           }
           else{
            element.status = 1
           }
          });
          // this.todayData=[];
          // this.tomorrowData=[];
          console.log(this.todayData);
        } 
        this.loaderservice.showLoader = false
        this.loader = false
        if(this.todayData.length == 0){
          setTimeout(() => {
            this.pickerA.open(); // Open the timepicker once the component has loaded
          }, 0);

        }
      }
      else if (
        data.responseType == SM_CONSTANTS.RESULT_API_GET_VIRTUAL_SERVICE_TIMINGS
      ) {
        this.todayData = []
        this.tomorrowData = []
        if (data.result) {
          let formattedData = this.formatTimeData(data.result)
          console.log(formattedData);
          formattedData.forEach((element: any) => {
            // console.log(element);
            element.timeList = typeof element.timeList == 'string' ? JSON.parse(element.timeList) : element.timeList;
            let tomorrowDay: any;
            let currDay = this.parentdata.day
            console.log(currDay);
            if (currDay > 6) {
              tomorrowDay = 1;
            } else {
              tomorrowDay = currDay + 1;
            }
            if (element.timeList[0].day == '1') {
              let timeSlots: any[] = []
              let try1: any[] = []
              element.timeList.forEach((item:any) => {
                // timeSlots.push(this.getTime(
                //   item.openTime,
                //   item.closeTime,
                //   '60'
                // ))
                try1 = this.getTimeForVirtual(
                    item.openTime,
                    item.closeTime,
                    '60',
                    item.meeting_details
                  )
                timeSlots = [...timeSlots, ...try1]


              });
              console.log("timeslots::::", timeSlots);
              if (currDay == 1) {
                this.todayData = timeSlots;
              }
              if (tomorrowDay == 1) {
                this.tomorrowData = timeSlots;
              }
            } else if (element.timeList[0].day == '2') {
              let timeSlots: any[] = []
              let try1: any[] = []
              element.timeList.forEach((item:any) => {
                // timeSlots.push(this.getTime(
                //   item.openTime,
                //   item.closeTime,
                //   '60'
                // ))
                try1 = this.getTimeForVirtual(
                  item.openTime,
                  item.closeTime,
                  '60',
                  item.meeting_details
                )
                timeSlots = [...timeSlots, ...try1]


              });
              console.log("timeslots::::", timeSlots);
              if (currDay == 2) {
                this.todayData = timeSlots;
              }
              if (tomorrowDay == 2) {
                this.tomorrowData = timeSlots;
              }
            } else if (element.timeList[0].day == '3') {
              let timeSlots: any[] = []
              let try1: any[] = []
              element.timeList.forEach((item:any) => {
                // timeSlots.push(this.getTime(
                //   item.openTime,
                //   item.closeTime,
                //   '60'
                // ))
                try1 = this.getTimeForVirtual(
                  item.openTime,
                  item.closeTime,
                  '60',
                  item.meeting_details
                )
                timeSlots = [...timeSlots, ...try1]


              });
              console.log("timeslots::::", timeSlots);
              if (currDay == 3) {
                this.todayData = timeSlots;
              }
              if (tomorrowDay == 3) {
                this.tomorrowData = timeSlots;
              }
            } else if (element.timeList[0].day == '4') {
              let timeSlots: any[] = []
              let try1: any[] = []
              element.timeList.forEach((item:any) => {
                // timeSlots.push(this.getTime(
                //   item.openTime,
                //   item.closeTime,
                //   '60'
                // ))
                try1 = this.getTimeForVirtual(
                  item.openTime,
                  item.closeTime,
                  '60',
                  item.meeting_details
                )
                timeSlots = [...timeSlots, ...try1]


              });
              console.log("timeslots::::", timeSlots);
              if (currDay == 4) {
                this.todayData = timeSlots;
              }
              if (tomorrowDay == 4) {
                this.tomorrowData = timeSlots;
              }
            } else if (element.timeList[0].day == '5') {
              let timeSlots: any[] = []
              let try1: any[] = []
              element.timeList.forEach((item:any) => {
                // timeSlots.push(this.getTime(
                //   item.openTime,
                //   item.closeTime,
                //   '60'
                // ))
                try1 = this.getTimeForVirtual(
                  item.openTime,
                  item.closeTime,
                  '60',
                  item.meeting_details
                )
                timeSlots = [...timeSlots, ...try1]


              });
              console.log("timeslots::::", timeSlots);
              if (currDay == 5) {
                this.todayData = timeSlots;
              }
              if (tomorrowDay == 5) {
                this.tomorrowData = timeSlots;
              }
            } else if (element.timeList[0].day == '6') {
              let timeSlots: any[] = []
              let try1: any[] = []
              element.timeList.forEach((item:any) => {
                // timeSlots.push(this.getTime(
                //   item.openTime,
                //   item.closeTime,
                //   '60'
                // ))
                try1 = this.getTimeForVirtual(
                  item.openTime,
                  item.closeTime,
                  '60',
                  item.meeting_details
                )
                timeSlots = [...timeSlots, ...try1]


              });
              console.log("timeslots::::", timeSlots);
              if (currDay == 6) {
                this.todayData = timeSlots;
              }
              if (tomorrowDay == 6) {
                this.tomorrowData = timeSlots;
              }
            } else if (element.timeList[0].day == '7') {
              let timeSlots: any[] = []
              let try1: any[] = []
              element.timeList.forEach((item:any) => {
                // timeSlots.push(this.getTime(
                //   item.openTime,
                //   item.closeTime,
                //   '60'
                // ))
                try1 = this.getTimeForVirtual(
                  item.openTime,
                  item.closeTime,
                  '60',
                  item.meeting_details
                )
                timeSlots = [...timeSlots, ...try1]


              });
              console.log("timeslots::::", timeSlots);
              if (currDay == 7) {
                this.todayData = timeSlots;
              }
              if (tomorrowDay == 7) {
                this.tomorrowData = timeSlots;
              }
            }
          });
          let currTime: any = new Date();
          // console.log(currTime);
          this.todayData.forEach((element) => {
            if(parentdata.isToday){
              // console.log(element);
              let fromTime: any = new Date(currTime).setHours(
                element.startTime.slice(0, 2),
                element.startTime.slice(3, 5),
                0,
                0
              );
              let toTime: any = new Date(currTime).setHours(
                element.endTime.slice(0, 2),
                element.endTime.slice(3, 5),
                0,
                0
              );
              // console.log(fromTime,toTime);
              if (fromTime <= currTime && currTime <= toTime) {
                console.log(
                  'Time is between ' +
                    element.startTime +
                    ' and ' +
                    element.endTime
                );
                element.status = 1;
              } else if (fromTime >= currTime) {
                element.status = 1;
              } else {
                console.log(
                  'Time is not between ' +
                    element.startTime +
                    ' and ' +
                    element.endTime
                );
                element.status = 0;
              }
            }
            else{
              element.status = 1
            }
          });
          // this.todayData=[];
          // this.tomorrowData=[];
          console.log(this.todayData);
        } 
        this.loaderservice.showLoader = false
        this.loader = false
        if(this.todayData.length == 0){
          setTimeout(() => {
            this.pickerA.open(); // Open the timepicker once the component has loaded
          }, 0);

        }
      }
     
    })


  }
  todayday:any = (new Date().getDay()) + 1
  comingday:any
  ngOnInit(): void {
    console.log('time data::::',this.parentdata);
    this.comingday = this.parentdata.day
    this.loader = true  
    // this.loaderservice.showLoader = true;
    if (this.parentdata.serviceType == "0") {
      this.apiservice.getHomeServiceTimeDetails(this.parentdata.entityHash);
    } else if(this.parentdata.serviceType == "1"){
      this.apiservice.getShopEntityTimeDetails(this.parentdata.entityHash);
    }
    else{
      this.apiservice.getVirtualServiceTimings(this.parentdata.entityHash)
    }
  }
  clickTodaytime(item: any) {
    if(item.status == 1){
      console.log(item);
      this.todayData.forEach(element => {
        element.isSelected = 0
      });
      item.isSelected = 1
    
      this.activemodal.close(item)
    }
  }

  onSave(){
    let selectedTime = this.todayData.filter((item:any) => item.isSelected == 1)
    console.log(selectedTime);
    this.activemodal.close(selectedTime[0])
  }
  selectedTime:any
  onTimeSelected(event:any){
    console.log(event);
    console.log(this.convertTo24HourFormat(event));
    
    let slot = this.getOneHourSlot(this.convertTo24HourFormat(event))
    console.log(slot);
    this.activemodal.close(
      {
        startTime: slot.start,
        endTime: slot.end
      }
    )
    
  }

  onClosed(event:any){
    this.activemodal.close()
  }
  getTime(openTime: any, closeTime: any, interval: any) {
    // let x = {
    //   slotInterval: 60,
    //   openTime: '09:00',
    //   closeTime: '21:00'
    // };

    //Format the time
    let startTime = moment(openTime, 'HH:mm');

    //Format the end time and the next day to it
    let endTime = moment(closeTime, 'HH:mm');

    //Times
    let allTimes = [];

    //Loop over the times - only pushes time with 60 minutes interval
    while (startTime < endTime) {
      //Push times
      let time = startTime.format('HH:mm');
      startTime.add(interval, 'minutes');
      let prevtime = startTime.format('HH:mm');
      // time = time + prevtime;
      let data = {
        startTime: time,
        endTime: prevtime,
        status: 0,
        appointmentsCount: 0,
        isSelected: 0
      };
      allTimes.push(data);
      //Add interval of 60 minutes
      // startTime.add(x.slotInterval, 'minutes');
    }

    return allTimes;
  }
  getTimeForVirtual(openTime: any, closeTime: any, interval: any,link:any) {
    // let x = {
    //   slotInterval: 60,
    //   openTime: '09:00',
    //   closeTime: '21:00'
    // };

    //Format the time
    let startTime = moment(openTime, 'HH:mm');

    //Format the end time and the next day to it
    let endTime = moment(closeTime, 'HH:mm');

    //Times
    let allTimes = [];

    //Loop over the times - only pushes time with 60 minutes interval
    while (startTime < endTime) {
      //Push times
      let time = startTime.format('HH:mm');
      startTime.add(interval, 'minutes');
      let prevtime = startTime.format('HH:mm');
      // time = time + prevtime;
      let data = {
        startTime: time,
        endTime: prevtime,
        status: 0,
        appointmentsCount: 0,
        isSelected: 0,
        link:link
      };
      allTimes.push(data);
      //Add interval of 60 minutes
      // startTime.add(x.slotInterval, 'minutes');
    }

    return allTimes;
  }

  tConv24(time24: any) {
    let ts: any = time24;
    let H: any = +ts.substr(0, 2);
    let h: any = H % 12 || 12;
    h = h < 10 ? '0' + h : h; // leading 0 at the left for 1 digit hours
    var ampm = H < 12 ? ' AM' : ' PM';
    ts = h + ts.substr(2, 3) + ampm;
    return ts;
  }
  getOneHourSlot(timeString:any) {
    // Split the time string into hours and minutes
    let [hours, minutes] = timeString.split(':').map(Number);
  
    // Adjust hours based on minutes (round down to nearest hour)
    let startHour = hours;
  
    // Calculate next hour
    let endHour = (startHour + 1) % 24;
  
    // Format hours to always be 2 digits (e.g., 08:00, 23:00)
    const formatHour = (hour:any) => hour.toString().padStart(2, '0');
  
    // Return the 1-hour slot in 24-hour format
    return {
      start: `${formatHour(startHour)}:00`,
      end: `${formatHour(endHour)}:00`
    };
  }
  convertTo24HourFormat(time:any) {
    // Extract hours, minutes, and AM/PM from the time string
    const [timePart, amPm] = time.split(' ');
    const [hoursStr, minutesStr] = timePart.split(':');
  
    // Convert string components to numbers
    let hours = parseInt(hoursStr, 10);
    const minutes = parseInt(minutesStr, 10);
  
    // Adjust hours based on AM/PM
    if (amPm.toLowerCase() === 'pm' && hours !== 12) {
        hours += 12;
    } else if (amPm.toLowerCase() === 'am' && hours === 12) {
        hours = 0;
    }
  
    // Construct a new Date object with a fixed date and the parsed time components
    const date = new Date(2000, 0, 1, hours, minutes);
  
    // Use Date methods to get hours, minutes, and seconds in 24-hour format
    const formattedHours = date.getHours().toString().padStart(2, "0");
    const formattedMinutes = date.getMinutes().toString().padStart(2, "0");
  
    const formattedTime = `${formattedHours}:${formattedMinutes}`;
  
    console.log(formattedTime);
  
    return formattedTime;
  }
  
formatTimeData(data: any) {
  const groupedData: { [key: number]: any } = {};

  data.forEach((item:any) => {
    const formattedItem = {
      day: item.day,
      hashId: item.hash_id,
      openTime: `${item.open_time}.000000`,
      closeTime: `${item.close_time}.000000`,
      operationDate: null,
      specialDayStatus: item.special_day_status,
      meeting_details: item.meeting_details ? (typeof item.meeting_details == 'string' ? JSON.parse(item.meeting_details) : item.meeting_details) : null
    };

    if (!groupedData[item.day]) {
      groupedData[item.day] = { timeList: [formattedItem] };
    } else {
      groupedData[item.day].timeList.push(formattedItem);
    }
  });

  return Object.values(groupedData);
}
  ngOnDestroy(): void {
    this.apisub.unsubscribe()
  }
}
